import { FC, useState, useEffect } from "react"
import { useNavigate, useParams } from "react-router"
import InputMask from "react-input-mask";
import Swal from "sweetalert2";

import './index.css'
import api from "../../../../services/api";
import { Loading } from "../../../../components/Loading";
import useAuth from "../../../../hooks/useAuth";
import { usePluginspace } from "../../../../hooks/usePluginspace";
import { cepNoMask } from "../../../../functions/mask";

const UpdateAddress: FC = () => {



    const [cep, setCep] = useState("");
    const [loading, setLoading] = useState(false);
    const [address, setAddress] = useState("");
    const [district, setDistrict] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [number, setNumber] = useState("");
    const [complement, setComplement] = useState("");
    const [ibge, setIbge] = useState('');


    const { loginInfo } = useAuth()
    const { getToken } = usePluginspace();
    const navigate = useNavigate();
    const { pluginspace_id, id_address } = useParams();
    const param = useParams();


    async function findCep(cep: string) {
        if (cep) {
            setLoading(true)
            return await api
                .get(`https://viacep.com.br/ws/${cep.replace("-", "")}/json/`)
                .then((response) => {

                    if (response.data.erro) {
                        setCity("");
                        setAddress("");
                        setDistrict("");
                        setState("");
                        Swal.fire({
                            icon: "warning",
                            title: "CEP inválido!",
                            text: "Verifique se o CEP foi digitado corretamente.",
                        });
                        return false;
                    } else {
                        if (response.data.ibge !== '')
                            setIbge(response.data.ibge);
                        if (response.data.localidade !== "")
                            setCity(response.data.localidade);
                        if (response.data.logradouro !== "")
                            setAddress(response.data.logradouro);
                        if (response.data.bairro !== "")
                            setDistrict(response.data.bairro);
                        if (response.data.uf !== "") setState(response.data.uf);

                        setLoading(false)
                        return true;
                    }
                })
                .catch(() => {
                    setLoading(false)
                    setCity("");
                    setAddress("");
                    setDistrict("");
                    setState("");
                    Swal.fire({
                        icon: "warning",
                        title: "CEP inválido!",
                        text: "Verifique se o CEP foi digitado corretamente.",
                    });
                    return false;
                });
        } else {
            return false
        }
    }


    async function saveAddress() {
        if (cep &&
            address &&
            district &&
            city &&
            state &&
            number) {

            setLoading(true);
            console.log(id_address)

            const newAddress = {
                zipCode: cep ? cepNoMask(cep) : '',
                addressId:parseInt(id_address!),
                customerId: loginInfo.id,
                street: address,
                number: number,
                district: district,
                city: city,
                state: state,
                extra: complement,
                reference: "",
                typeAddress: "main",
                ibge
            }

            await api
                .put(`/api/customer/address`, newAddress, {
                    headers: {
                        Authorization: `Bearer ${await getToken()}`,
                    },
                })
                .then((response) => {
                    setLoading(false);


                    if (response.data.success === true) {

                        navigate(`/${pluginspace_id}/profile/addresses`);
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: "Erro!",
                            text: "Falha ao salvar endereço",
                        });
                    }
                })
                .catch((err) => {
                    console.log(err)

                    Swal.fire({
                        icon: "error",
                        title: "Erro!",
                        text: "Falha ao salvar endereço",
                    });
                    setLoading(false);
                    console.log(err);
                });




        } else {
            Swal.fire({
                icon: "warning",
                title: "Atenção",
                text: "Verifique se preencheu todos os campos",
            });
        }
    }

    const loadAddresses = async () => {

        setLoading(true);
        try {


            await api
                .post(
                    `/api/customer/filter`,
                    {
                        cpf: loginInfo.identifier,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${await getToken()}`,
                        },
                    }
                )
                .then(async (response: any) => {
                    setLoading(false);
                    if (response.data.data.length > 0) {
                        const data = response.data.data[0];

                        const [address] = data.customerAddresses.filter((add: any) => add.id == id_address)
                        setState(address.state)
                        setCity(address.city)
                        setCep(address.zipCode)
                        setDistrict(address.district)
                        setAddress(address.street) 
                        setNumber(address.number)
                        setComplement(address.complement)


                    }
                })
                .catch((err: any) => {
                    setLoading(false);
                    console.log(err);
                });
        } catch (error) {
            console.log(error)
            return
        }

    }


    useEffect(() => {
        loadAddresses()
    }, [])



    return (
        <>
            {loading ? (
                <Loading
                    type="spinningBubbles"
                    color="#FFF"
                    width={64}
                    height={64}
                />
            ) : (
                <div className="addressContentPage">

                    <div className="headerAddress">
                        <h4>Adicionar endereço</h4 >
                    </div >

                    <div className="addressContentBody">
                        {/*CEP */}
                        <div className="inputGroupAddresses">
                            <div className="">
                                <label>CEP

                                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none">
                                        <circle cx="4" cy="4.5" r="4" fill="#37393D" />
                                    </svg>

                                </label>
                                <InputMask
                                    className={`inputsContainer`}
                                    mask="99999-999"
                                    type="text"
                                    value={cep}
                                    onChange={(event) =>
                                        setCep(event.target.value)
                                    }
                                    onBlur={(event) => {
                                        findCep(event.target.value);
                                    }}
                                />
                            </div>

                            <button><span>
                                Usar Localizacao atual</span></button>
                        </div>

                        {/*Logradouro */}
                        <div className="inputGroupAddresses">
                            <div className="">
                                <label>Logradouro

                                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none">
                                        <circle cx="4" cy="4.5" r="4" fill="#37393D" />
                                    </svg>

                                </label>
                                <input
                                    className={`inputsContainer`}
                                    type="text"
                                    value={address}
                                    onChange={(event) =>
                                        setAddress(event.target.value)
                                    }
                                    onBlur={(event) => {

                                    }}
                                />
                            </div>

                            <div className="">
                                <label>Bairro

                                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none">
                                        <circle cx="4" cy="4.5" r="4" fill="#37393D" />
                                    </svg>

                                </label>
                                <input
                                    className={`inputsContainer`}
                                    type="text"
                                    value={district}
                                    onChange={(event) =>
                                        setDistrict(event.target.value)
                                    }
                                    onBlur={(event) => {

                                    }}
                                />
                            </div>
                        </div>

                        {/*Numero e Complemento */}
                        <div className="inputGroupAddresses">
                            <div className="">
                                <label>Número

                                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none">
                                        <circle cx="4" cy="4.5" r="4" fill="#37393D" />
                                    </svg>

                                </label>
                                <input
                                    className={`inputsContainer`}
                                    type="text"
                                    value={number}
                                    onChange={(event) =>
                                        setNumber(event.target.value)
                                    }
                                    onBlur={(event) => {

                                    }}
                                />
                            </div>
                            <div className="">
                                <label>Complemento

                                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none">
                                        <circle cx="4" cy="4.5" r="4" fill="#37393D" />
                                    </svg>

                                </label>
                                <input
                                    className={`inputsContainer`}
                                    type="text"
                                    value={complement}
                                    onChange={(event) =>
                                        setComplement(event.target.value)
                                    }
                                    onBlur={(event) => {

                                    }}
                                />
                            </div>
                        </div>

                        {/*Cidade estado */}
                        <div className="inputGroupAddresses">
                            <div className="">
                                <label>Cidade

                                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none">
                                        <circle cx="4" cy="4.5" r="4" fill="#37393D" />
                                    </svg>

                                </label>
                                <input
                                    className={`inputsContainer`}
                                    type="text"
                                    value={city}
                                    onChange={(event) =>
                                        setCity(event.target.value)
                                    }
                                    onBlur={(event) => {

                                    }}
                                />
                            </div>
                            <div className="">
                                <label>Estado

                                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none">
                                        <circle cx="4" cy="4.5" r="4" fill="#37393D" />
                                    </svg>

                                </label>
                                <input
                                    className={`inputsContainer`}
                                    type="text"
                                    value={state}
                                    onChange={(event) =>
                                        setState(event.target.value)
                                    }
                                    onBlur={(event) => {

                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    {/*Botão de Salvar */}
                    <div className="saveButton">
                        <button onClick={() => saveAddress()}>
                            <span>Salvar</span>
                        </button>
                    </div>


                </div >
            )

            }
        </>
    )
}

export { UpdateAddress }